import { useQuery } from 'react-query';
import { getStories } from '@yandex-int/k-common/client/api';
import { getUniqueQueryKeys } from 'utils/getUniqueQueryKey';

const keys = getUniqueQueryKeys(['getStories']);

export function useGetTeacherStories({ grades, subjects }: { grades?: number[]; subjects?: string[] }) {
    return useQuery([keys.getStories, grades, subjects], () => getStories({ subjects, grades }), {
        onError: () => {},
        staleTime: Infinity,
    });
}
